import script from "./CreditPeriodDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditPeriodDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CreditPeriodDashboard.vue?vue&type=style&index=0&id=183194e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-183194e4"]])

export default __exports__